import { render, staticRenderFns } from "./mdbListView.vue?vue&type=template&id=831f0512&scoped=true&"
import script from "./mdbListView.vue?vue&type=script&lang=js&"
export * from "./mdbListView.vue?vue&type=script&lang=js&"
import style0 from "./mdbListView.vue?vue&type=style&index=0&id=831f0512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831f0512",
  null
  
)

export default component.exports